export const NAV_SEARCH_TEST_ID = "nav-search";
